// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"e11b71ad","239":"dd6cd2f0","453":"b3d315c6","455":"66885585"}[chunkId] + ".chunk.js";
};